// AppInsights.js
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { appHistory } from 'components/History';
import { returnAppInsightsKey } from 'Setup';

const reactPlugin = new ReactPlugin();

const appInsightsKey = returnAppInsightsKey()

const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: appInsightsKey,
        extensions: [reactPlugin],
        extensionConfig: {
          [reactPlugin.identifier]: { history: appHistory }
        }
    }
});

appInsights.loadAppInsights();

export { reactPlugin, appInsights };

//https://docs.microsoft.com/en-us/azure/azure-monitor/app/javascript-react-plugin